/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import EditorMoreIcon from '@atlaskit/icon/glyph/editor/more';
import Tooltip from '@atlaskit/tooltip';
import { i18n } from '../../shared';
import * as styles from './styles';

/**
 * Test id for wrapper button
 */
export var RENDER_SHOWMORE_TESTID = 'show-more-button';
export var RENDER_WRAPPER_TESTID = 'show-more-wrapper';
/**
 * Show more custom emojis button
 */
export var ShowMore = function ShowMore(_ref) {
  var onClick = _ref.onClick,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? {} : _ref$className,
    buttonStyle = _ref.buttonStyle;
  return jsx("div", {
    className: className.container,
    css: styles.moreEmojiContainerStyle,
    style: style.container,
    "data-testid": RENDER_WRAPPER_TESTID
  }, jsx("div", {
    css: styles.separatorStyle
  }), jsx(FormattedMessage, i18n.messages.moreEmoji, function (message) {
    return jsx(Tooltip, {
      content: message
    }, jsx("button", {
      className: className.button,
      css: [styles.moreButtonStyle, buttonStyle],
      "aria-label": i18n.messages.moreEmoji.defaultMessage,
      type: "button",
      style: style.button,
      onClick: onClick,
      "data-testid": RENDER_SHOWMORE_TESTID
    }, jsx(EditorMoreIcon, {
      label: "More"
    })));
  }));
};